const ADD_TEAM = 'ADD_TEAM';
const REMOVE_TEAM = 'REMOVE_TEAM';
const ADD_SEASON = 'ADD_SEASON';
const REMOVE_SEASON = 'REMOVE_SEASON';
const ADD_GAME = 'ADD_GAME';
const REMOVE_GAME = 'REMOVE_GAME';
const REMOVE_ALL_GAMES = 'REMOVE_ALL_GAMES';
export const RESET_TEAM_SEASON_GAMES_SELECTION = 'RESET_SELECTION';

const INITIAL_STATE = {
  team: '',
  season: [],
  games: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_TEAM:
      return {
        team: action.payload,
        season: [],
        games: [],
      };
    case REMOVE_TEAM:
      return {
        team: '',
        season: [],
        games: [],
      };
    case ADD_SEASON:
      return {
        ...state,
        season: action.payload,
        games: [],
      };
    case REMOVE_SEASON:
      return {
        ...state,
        season: [],
        games: [],
      };
    case ADD_GAME:
      return {
        ...state,
        games: state.games.concat(action.payload),
      };
    case REMOVE_GAME:
      return {
        ...state,
        games: state.games.filter(game => !action.payload.includes(game)),
      };
    case REMOVE_ALL_GAMES:
      return {
        ...state,
        games: [],
      };
    case RESET_TEAM_SEASON_GAMES_SELECTION:
      return {
        team: '',
        season: [],
        games: [],
      };
    default:
      return state;
  }
}

export function addTeam(team) {
  return { type: ADD_TEAM, payload: team };
}

export function removeTeam() {
  return { type: REMOVE_TEAM, payload: null };
}

export function addSeason(season) {
  return { type: ADD_SEASON, payload: season };
}

export function removeSeason() {
  return { type: REMOVE_SEASON, payload: null };
}

export function addGame(game) {
  return { type: ADD_GAME, payload: game };
}

export function removeGame(game) {
  return { type: REMOVE_GAME, payload: game };
}

export function removeAllGames() {
  return { type: REMOVE_ALL_GAMES, payload: null };
}

export function resetTeamSeasonGameSelection() {
  return { type: RESET_TEAM_SEASON_GAMES_SELECTION };
}
